module["exports"] = ["Asiatic Lion", "Barbary Lion", "West African Lion", "Northeast Congo Lion", "Masai Lion", "Transvaal lion", "Cape lion"];